import { render, staticRenderFns } from "./ResumoPacientesOrtodontia.vue?vue&type=template&id=206ac6c8&scoped=true"
import script from "./ResumoPacientesOrtodontia.vue?vue&type=script&lang=js"
export * from "./ResumoPacientesOrtodontia.vue?vue&type=script&lang=js"
import style0 from "./ResumoPacientesOrtodontia.vue?vue&type=style&index=0&id=206ac6c8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ac6c8",
  null
  
)

export default component.exports